module.exports = __webpack_public_path__ + "static/media/profile.ccddccd3.jpg";